
import { supabase } from '@/integrations/supabase/client';
import { getProfile } from '@/services/profileService';

export const signIn = async (email: string, password: string) => {
  const { error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  return { error };
};

export const signOut = async () => {
  try {
    await supabase.auth.signOut({ scope: 'local' });
  } catch {
    // ignore
  }

  try {
    await supabase.auth.signOut({ scope: 'global' });
  } catch {
    // ignore
  }

  window.location.replace('/admin/login');
};

export const resetPassword = async (email: string) => {
  const { error } = await supabase.functions.invoke('send-password-reset', {
    body: {
      email,
      redirectTo: `${window.location.origin}/reset-password`,
      flavor: 'admin',
    },
  });
  return { error };
};

export const changePassword = async (newPassword: string) => {
  const { error } = await supabase.auth.updateUser({
    password: newPassword
  });
  return { error };
};

export const updateProfile = async (userId: string, updates: { full_name?: string }) => {
  try {
    // First try to update in platform_admins table
    const { data: platformAdmin } = await supabase
      .from('platform_admins')
      .select('id')
      .eq('id', userId)
      .maybeSingle();

    if (platformAdmin) {
      const { error: platformError } = await supabase
        .from('platform_admins')
        .update({
          full_name: updates.full_name,
          updated_at: new Date().toISOString()
        })
        .eq('id', userId);

      if (platformError) {
        return { error: platformError };
      }
    } else {
      // Try to update in organization_members table
      const { error: orgError } = await supabase
        .from('organization_members')
        .update({
          full_name: updates.full_name,
          updated_at: new Date().toISOString()
        })
        .eq('id', userId);

      if (orgError) {
        return { error: orgError };
      }
    }

    // Refresh profile data
    const updatedProfile = await getProfile(userId);
    return { error: null, profile: updatedProfile };
  } catch (error) {
    return { error };
  }
};

export const updateInvitationStatusOnSignIn = async (_userId: string) => {
  try {
    await supabase.rpc('accept_invitation_on_signin');
  } catch {
    // ignore
  }
};
